import { Grid } from "@material-ui/core";
import { useRecoilValue } from "recoil";
import { CounterpartyRole } from "../../../models/generated/graphql";
import { caseAgreementOrganizationRole } from "../../../store/cases";
import { DetailsCard } from "./DetailCard";
import SingleCard from "./SingleCard";

export const mapOrganizationRoleToGrossKey = (role: CounterpartyRole | "payable") => {
	switch (role) {
		case "BUYER":
			return "gross-expenditure";
		case "SELLER":
			return "gross-revenue";
		case "OBSERVER":
			return "gross-amount";
		default:
			return role;
	}
};

export const mapOrganizationRoleToNetKey = (role: CounterpartyRole | "payable") => {
	switch (role) {
		case "BUYER":
			return "net-expenditure";
		case "SELLER":
			return "net-revenue";
		case "OBSERVER":
			return "net-amount";
		default:
			return role;
	}
};

const hiddenValueMask = "XX";

const Header = (props: { data: Array<any> | undefined; isDrawerOpen: boolean } | undefined) => {
	const organizationRole = useRecoilValue(caseAgreementOrganizationRole);
	const headersData = props?.data![0].headers[0];

	if (!props || !props.data) return <></>;

	return (
		<Grid container spacing={4}>
			<Grid item xs={2}>
				<SingleCard
					property={mapOrganizationRoleToGrossKey(organizationRole)}
					value={headersData.total}
					isTooltipShown={headersData.total !== hiddenValueMask}
					currency={headersData.currency}
					decimalPrecision="2"
				/>
			</Grid>
			<Grid item xs={2}>
				<SingleCard
					property={mapOrganizationRoleToNetKey(organizationRole)}
					value={headersData.payable}
					isTooltipShown={headersData.total !== hiddenValueMask}
					currency={headersData.currency}
					decimalPrecision="2"
				/>
			</Grid>
			<Grid item xs={2}>
				<SingleCard
					property="variable"
					value={headersData.variable}
					isTooltipShown={headersData.total !== hiddenValueMask}
					currency={headersData.currency}
					decimalPrecision="2"
				/>
			</Grid>
			<Grid item xs={6}>
				<DetailsCard headersData={headersData} isDrawerOpen={props.isDrawerOpen} />
			</Grid>
		</Grid>
	);
};

export default Header;
